import { render, staticRenderFns } from "./QueueMonitoring.vue?vue&type=template&id=3e65b52c&scoped=true&"
import script from "./QueueMonitoring.vue?vue&type=script&lang=js&"
export * from "./QueueMonitoring.vue?vue&type=script&lang=js&"
import style0 from "./QueueMonitoring.vue?vue&type=style&index=0&id=3e65b52c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e65b52c",
  null
  
)

export default component.exports